import { Component, Input, Output, EventEmitter } from '@angular/core';
import { IOrder, IOrderDelivery, ORDER_LINE_STATES } from '@cakeiteasy/web-utils';

@Component({
  standalone: false,
  selector: 'order-info-pickup',
  templateUrl: './order-info-pickup.component.html'
})
export class OrderInfoPickupComponent {
  @Input() deliveryOrder: IOrderDelivery;
  @Input() order: IOrder;
  @Input() showDeliveryEdit = false;
  @Output() onDeliveryEdit = new EventEmitter<void>();
  @Output() onShowMap = new EventEmitter<void>();

  public ORDER_LINE_STATES = ORDER_LINE_STATES;
}
